<template>
    <general-link class="navbar-brand"><slot></slot></general-link>
</template>
